<!--Displays all contact information for a given office in an organized format.
    At minimum, this will display an address, all other items are optional.
-->

<template>
  <main>
    {{ setVariables() }}
    <hr class="secondary-color" />
    <h5 class="secondary-color text-white py-1">
      <strong>{{ address.location_name }}</strong>
    </h5>
    <hr class="secondary-color" />
    <p v-if="address.address">{{ address.address }}</p>
    <p v-if="address.city && address.state && address.zip_code">
      {{ address.city }}, {{ address.state }} {{ address.zip_code }}
    </p>
    <a :href="getURL(address)" target="_blank" v-if="address.address"
      >View Location on Map</a
    >

    <!--Phone Numbers-->

    <div class="mt-3">
      <div v-for="number in phone_numbers" :key="number.id">
        <p v-if="number.phone_number.header">
          <strong>{{ number.phone_number.header }}</strong>
        </p>
        <p v-if="number.phone_number.number_type == 'Phone'">
          <strong
            >Phone: ({{ number.phone_number.area_code }})
            {{ number.phone_number.phone_number }}</strong
          >
        </p>
        <p v-if="number.phone_number.number_type == 'Fax'">
          <strong
            >Fax: ({{ number.phone_number.area_code }})
            {{ number.phone_number.phone_number }}</strong
          >
        </p>
      </div>
    </div>

    <!--Hours of Operation-->

    <div
      v-if="hours.start_time != null || hours.additional_information"
      class="mt-3"
    >
      <p><strong>Hours of Operation:</strong></p>
      <p class="adjacent" v-if="hours.start_day && hours.end_day">
        <strong>{{ hours.start_day }} - {{ hours.end_day }}: </strong>
      </p>
      <p class="adjacent" v-if="hours.start_day">
        <strong>{{ hours.start_day }}</strong>
      </p>
      <p class="adjacent ml-2">
        {{ toTimeString(hours.start_time) }} -
        {{ toTimeString(hours.end_time) }}
      </p>
      <p v-if="hours.additional_information">
        <strong>Additional Information:</strong>
      </p>
      <p v-if="hours.additional_information">
        {{ hours.additional_information }}
      </p>
    </div>

    <!--Emails-->

    <div class="mt-3" v-if="emails.length != 0">
      <p>
        <strong>Staff:</strong>
      </p>
      <div v-for="email in emails" :key="email.id" class="mt-3">
        <p v-if="email.email.contact_title">
          <strong>{{ email.email.contact_title }}:</strong>
        </p>
        <p v-if="email.email.contact_name">{{ email.email.contact_name }}</p>
        <p v-if="email.email.email">
          <em>{{ email.email.email }}</em>
        </p>
      </div>
    </div>
  </main>
</template>

<script>
import shared from "@/shared";
export default {
  name: "OfficeInfo",
  props: {
    block: Object,
    name: String,
    about: String,
  },
  data() {
    return {
      address: String,
      hours: String,
      phone_numbers: String,
      emails: String,
    };
  },
  methods: {
    setVariables() {
      this.address = this.block.office_info[0].address;
      this.hours = this.block.office_info[1].hours;
      this.phone_numbers = this.block.office_info[2].phone_numbers;
      this.emails = this.block.office_info[3].emails;
    },
    toTimeString: function (time) {
      return shared.TwelveHrTime(time);
    },
    getURL(address) {
      var url = "https://www.google.com/maps/place/";
      url +=
        address.address +
        " " +
        address.city +
        " " +
        address.state +
        " " +
        address.zip_code +
        "/";
      return url;
    },
  },
};
</script>

<style scoped>
.adjacent {
  display: inline-block;
}
p {
  margin: 0px;
}
</style>